import React from 'react';
import dynamic from 'next/dynamic';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import get from 'lodash/get';
import { AvatarLarge, Modal } from '../../components';
import { Link } from 'react-router-dom';

import NewsLink from '../NewsLink/NewsLink';

import css from './LatestNewsSection.module.scss';
import NewsImage from '../NewsImage/NewsImage';

const Swiper =
  typeof window !== 'undefined'
    ? require('swiper/react').Swiper
    : dynamic(() => import('swiper/react'), {
      ssr: false,
    });
const SwiperSlide =
  typeof window !== 'undefined'
    ? require('swiper/react').SwiperSlide
    : dynamic(() => import('swiper/react'), {
      ssr: false,
    });
const Navigation =
  typeof window !== 'undefined'
    ? require('swiper').Navigation
    : dynamic(() => import('swiper'), {
      ssr: false,
    });

function LatestNewsPopup(props) {

  const {
    news,
    slideIndex,
    isModalOpen,
    onManageDisableScrolling,
    onHandleClosePopup
  } = props;


  return news && news.length > 0 ? (
    <>
      {slideIndex >= 0 && (
        <Modal
          id="LatestNewsSection.newsPoppup"
          contentClassName={css.newsPopupContent}
          isOpen={isModalOpen}
          onClose={() => onHandleClosePopup()}
          onManageDisableScrolling={onManageDisableScrolling}
        >
          <Swiper
            key="LatestNewsSection.newsPoppupSwiper"
            modules={[Navigation]}
            navigation={{
              nextEl: '.custom_next',
              prevEl: '.custom_prev',
            }}
            spaceBetween={10}
            slidesPerView={1}
            onSwiper={swiper => { }}
            onSlideChange={() => { }}
            initialSlide={+slideIndex}
            autoHeight={true}
          >
            <div className="custom_next">
              {' '}
              {/* we need to add our own arrows, SwiperJs doesn't show default ones  */}
              <ArrowForwardIosIcon style={{ fontSize: '40px' }} />
            </div>
            <div className="custom_prev">
              <ArrowBackIosNewIcon style={{ fontSize: '40px' }} />
            </div>
            {news.map((n, index) => {
              const link = get(n, 'link', null);
              const title = get(n, 'title', '');
              const imgUrl = get(n, 'image.url', null);
              const listingId = get(n, 'listingId', null);

              return (
                <SwiperSlide key={index.toString()}>
                  <div className={css.newsItem}>
                    {link ? (
                      <NewsLink className={css.title} link={link}>
                        {title}
                      </NewsLink>
                    ) : (
                      <span className={css.title}>{title}</span>
                    )}
                    <NewsImage
                      imgUrl={imgUrl}
                      link={link}
                      imageClassName={css.image}
                      iconClassName={css.newsIcon}
                    />
                    <p className={css.description}>{n?.description}</p>
                    <div className={css.authorInfo}>
                      <AvatarLarge
                        className={css.authorAvatar}
                        user={n?.author}
                        disableProfileLink
                      />
                      {!!n.companyName && (
                        <h3 className={css.authorName}>
                          {listingId ? (
                            <Link to={`l/${listingId}`}>{n.companyName}</Link>
                          ) : (
                            <>{n.companyName}</>
                          )}
                        </h3>
                      )}
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </Modal>
      )}
    </>
  ) : null;
}

export default LatestNewsPopup;
